import React from "react";
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { Navbar, Nav } from "react-bootstrap";
// import history from "./services/history.service.js";
import Clients from "./pages/clients";
import Login from "./pages/login";
import Users from "./pages/users";
import Home from "./pages/home";
import "bootstrap/dist/css/bootstrap.min.css";
import Uvr from "./pages/uvr"; 
import Documents from "./pages/documents";
import Search from "./pages/search";
import Credits from "./pages/credits";
import ClosedPeriods from "./pages/closedPeriods";

import Divider from '@mui/material/Divider';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Version from "./components/version";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      roleId: "",
    };
  }

  componentDidMount = () => {
    let loggedIn = window.sessionStorage.getItem("loggedIn");
    if (loggedIn === "true") {
      this.setState({
        roleId: JSON.parse(
          atob(window.sessionStorage.getItem("localToken").split(".")[1])
        ).roleId,
      });
      console.log(document.getElementById("content-scrollbar"));
      document
        .getElementById("content-scrollbar")
        .addEventListener("scroll", () => {
          const contentDiv = document.getElementById("content-scrollbar");
          if (contentDiv.scrollTop > 0) {
            document.getElementById("nav-bar").classList.add("scrolled");
          } else {
            document.getElementById("nav-bar").classList.remove("scrolled");
          }
        });
    }
  };

  logOut = () => {
      sessionStorage.clear();
      sessionStorage.setItem("loggedIn", false);
      window.location.href = '/login';
  }

  //<div><hr style={{borderColor : '#cb1016', height: .5}}/></div>

  render = () => {
    let username = window.sessionStorage.getItem("username");
    return (
      <BrowserRouter>
        <div className="body">
        
          {window.sessionStorage.getItem("localToken") && (
      
            <div className="nav-bar" id="nav-bar" style={{borderColor:'#cb1016'}}>
              <Navbar style={{height:"6rem",borderColor : '#cb1016'}} bg="white" expand="lg">
                <div className="title">
                    <Navbar.Brand href={this.state.roleId === 1 ? '/home' : '/clients/search/' + username}>
                    <img
                      src={require("./res/logo-mobilia.jpg")}
                      height="90"

                      style={{marginLeft:"2.5rem"}}
                      
                      className="d-inline-block align-top"
                      alt="React Bootstrap logo"
                    />
                  </Navbar.Brand>
                </div>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                  
                </Navbar.Collapse>
                <Navbar.Collapse className="justify-content-end">
                      {window.sessionStorage.getItem("localToken") ? (
                    <Navbar.Text>
                      <Nav.Link href="/login" >
                          <ListItem className="navbar-element" button key={""}>
                              <ListItemIcon>
                                <span style={{ color:"#cb1016" ,fontSize:"13pt"}} > Perfil  <AccountBoxIcon style={{color: '#cb1016'}}/> </span>
                              </ListItemIcon>
                          </ListItem>
                      </Nav.Link>
                      <Nav.Link onClick={this.logOut} >
                          <ListItem className="navbar-element-2" button key={""}>
                              <ListItemIcon>
                                <span style={{ color:"#cb1016" ,fontSize:"13pt"}} > Cerrar Sesión</span>
                              </ListItemIcon>
                          </ListItem>
                      </Nav.Link>
                    </Navbar.Text>
                  ) : (
                    <Navbar.Text>
                      <a href="/login">Iniciar sesión</a>
                    </Navbar.Text>
                  )}
                </Navbar.Collapse>
          
              </Navbar>
              
            </div>
            
                  
          )}
          <Divider style={{color:"#cb1016", textDecorationThickness:"5rem"}}/>
          <div className="content" id="content-scrollbar">
            <Routes>
              <Route path="/home" element={<Home />} />
              <Route path="/" element={<Navigate to="/login" replace />} />
              <Route path="/login" element={<Login />} />
              <Route path="/clients/*" element={<Clients />} />
              <Route path="/credits/*" element={<Credits />} />
              <Route path="/users" element={<Users />} />
              <Route path="/search/*" element={<Search />} />
              <Route path="/uvr" element={<Uvr />} />
              <Route path="/documents" element={<Documents />} />
              <Route path="/closedPeriods" element={<ClosedPeriods />} />
            </Routes>
          </div>
          <Version />

        </div> 
      </BrowserRouter>
    );
  };
}

export default App;
